import React from "react";
import { connect } from "react-redux";
import { FormattedText } from "../common/FormattedText";
import { BreadcrumbsContainer } from "styles/components/BreadcrumbsContainer";

const LearningModuleBreadcrumb = ({ name }) => (
  <BreadcrumbsContainer>
    <FormattedText text={name} adjustFont="true"></FormattedText>
  </BreadcrumbsContainer>
);

export default connect((state) => {
  const name = state.learningLibrary.learningModule.name;

  return { name };
})(LearningModuleBreadcrumb);
